"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDecisionSummary = exports.getStatus = exports.getClientModerationResult = void 0;
var moment_1 = __importDefault(require("moment"));
var date_1 = require("@utils/date/date");
var duration_1 = require("@utils/date/duration");
var _i18n_1 = __importDefault(require("@i18n"));
var getCurrentQueueNameAndId_1 = require("@utils/getCurrentQueueNameAndId");
var translations_1 = require("@features/ItemCommon/components/DecisionSummary/util/translations");
/**
 * When the decision is taken by the client (outside of Implio), we show the client moderation result
 * @param job
 */
function getClientModerationResult(job) {
    if (job && job.ad && job.ad.current && job.ad.current.meta && job.ad.current.meta.clientModerationResult) {
        var clientModerationResult = job.ad.current.meta.clientModerationResult;
        return clientModerationResult[clientModerationResult.length - 1];
    }
    return null;
}
exports.getClientModerationResult = getClientModerationResult;
/**
 * If the client took the decision we show the client result, otherwise we show the implio moderation result
 * @param job
 * @param showClientResult
 * @param clientModerationResult
 */
function getStatus(job, showClientResult, clientModerationResult) {
    var _a;
    var status = showClientResult ? clientModerationResult === null || clientModerationResult === void 0 ? void 0 : clientModerationResult.outcome : (_a = job === null || job === void 0 ? void 0 : job.ad) === null || _a === void 0 ? void 0 : _a.current.meta.status;
    return status;
}
exports.getStatus = getStatus;
/**
 * The date format is '2023-10-20T12:51:06.034Z' we parse it to get the timestamp
 * @param job
 * @param showClientResult
 * @param clientModerationResult
 */
function getTimeStamp(job, showClientResult, clientModerationResult) {
    var _a;
    if (showClientResult && clientModerationResult) {
        return new Date(clientModerationResult.timestamp);
    }
    return new Date(((_a = job === null || job === void 0 ? void 0 : job.ad) === null || _a === void 0 ? void 0 : _a.current.timestamp) || '');
}
/**
 * Get Refusal reason if the decison has been taken by implio
 * if it's an external decision return an empty string
 */
function getRefusalReasons(job, showClientResult) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    if (showClientResult) {
        return '';
    }
    if (((_c = (_b = (_a = job === null || job === void 0 ? void 0 : job.ad) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.meta) === null || _c === void 0 ? void 0 : _c.status) === 'refused' &&
        Array.isArray((_f = (_e = (_d = job === null || job === void 0 ? void 0 : job.ad) === null || _d === void 0 ? void 0 : _d.current) === null || _e === void 0 ? void 0 : _e.meta) === null || _f === void 0 ? void 0 : _f.decisions) &&
        ((_j = (_h = (_g = job === null || job === void 0 ? void 0 : job.ad) === null || _g === void 0 ? void 0 : _g.current) === null || _h === void 0 ? void 0 : _h.meta) === null || _j === void 0 ? void 0 : _j.decisions.length) > 0) {
        return (_k = job.ad.current) === null || _k === void 0 ? void 0 : _k.meta.decisions[0].name;
    }
    return '';
}
function getPreviousQueue(job) {
    var e_1, _a;
    var _b;
    var prevQueueName = '';
    var history = (_b = job === null || job === void 0 ? void 0 : job.ad) === null || _b === void 0 ? void 0 : _b.history.slice(1);
    if (history) {
        try {
            for (var history_1 = __values(history), history_1_1 = history_1.next(); !history_1_1.done; history_1_1 = history_1.next()) {
                var historyItem = history_1_1.value;
                var _c = __read((0, getCurrentQueueNameAndId_1.getCurrentQueueNameAndId)(historyItem), 1), queueName = _c[0];
                if (queueName) {
                    prevQueueName = queueName;
                    break;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (history_1_1 && !history_1_1.done && (_a = history_1.return)) _a.call(history_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    return prevQueueName;
}
var getDecisionSummary = function (job) {
    var _a, _b, _c, _d, _e, _f, _g;
    if (!job || !job.ad) {
        return null;
    }
    var showClientResult = ((_c = (_b = (_a = job === null || job === void 0 ? void 0 : job.ad) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.actor) === null || _c === void 0 ? void 0 : _c.domain) === 'client';
    var clientModerationResult = getClientModerationResult(job);
    var status = getStatus(job, showClientResult, clientModerationResult);
    var hasDecision = status && ['approved', 'refused', 'no decision'].indexOf(status) !== -1;
    var timestamp = getTimeStamp(job, showClientResult, clientModerationResult);
    var timeEntered = new Date(((_e = (_d = job === null || job === void 0 ? void 0 : job.ad) === null || _d === void 0 ? void 0 : _d.current) === null || _e === void 0 ? void 0 : _e.meta.timeEntered) || '');
    var timeEnteredFormatted = (0, date_1.formatDateWithSeconds)(timeEntered);
    var timeSinceEntered = (0, duration_1.getDurationText)(timeEntered);
    var timeDecisionMade = new Date(((_g = (_f = job === null || job === void 0 ? void 0 : job.ad) === null || _f === void 0 ? void 0 : _f.current) === null || _g === void 0 ? void 0 : _g.timestamp) || '');
    var utcOffset = (0, moment_1.default)().utcOffset() / 60;
    var timeZone = "GMT".concat(utcOffset > 0 ? "+".concat(utcOffset) : utcOffset);
    var timestampFormatted = (0, date_1.formatDateWithSeconds)(timestamp);
    var icons = {
        approved: 'check',
        refused: 'cross',
        'no decision': 'dash',
        reviewable: 'send-to',
        deferred: 'send-to',
        processing: 'cog',
        new: '',
    };
    var _h = (0, date_1.getIntervalFromNow)(timestamp), timeNum = _h.timeNum, timeUnit = _h.timeUnit;
    function getStatusLabel(status) {
        if (!job || !job.ad) {
            return '';
        }
        var domain = job.ad.current.actor.domain; // agent OR processor OR client
        var agent = job.ad.current.actor.id;
        var client = (clientModerationResult === null || clientModerationResult === void 0 ? void 0 : clientModerationResult.actorId) || '';
        var whoMadeDecision = (domain === 'agent' && agent) || (domain === 'client' && client);
        var byWho = whoMadeDecision ? " by ".concat(whoMadeDecision) : '';
        var refusalReason = getRefusalReasons(job, showClientResult);
        switch (status) {
            case 'no decision':
                return (0, translations_1.getNoDecisionStatusLabel)(byWho);
            case 'approved':
            case 'refused':
                return (0, translations_1.getDecisionStatusLabel)(status, domain, byWho, refusalReason);
            case 'reviewable':
                return (0, translations_1.getReviewableStatusLabel)(job.currentQueueName);
            case 'deferred':
                return (0, translations_1.getDeferredStatusLabel)(getPreviousQueue(job), (job === null || job === void 0 ? void 0 : job.currentQueueName) || '', byWho);
            case 'new':
                return (0, translations_1.getNewLabel)();
            default:
                return (0, translations_1.getNewLabel)();
        }
    }
    return {
        status: status,
        getTimeSinceEntered: function () { return (0, duration_1.getDurationText)(timeEntered); },
        getDecisionFromNow: function (lastHistoryTimestampMoment) { return (0, date_1.getIntervalFromNow)(new Date(lastHistoryTimestampMoment)); },
        timestamp: timestamp,
        hasDecision: hasDecision,
        iconName: icons[status],
        statusActorText: getStatusLabel(status),
        timeToDecision: hasDecision
            ? (0, translations_1.getTimeToDecisionLabel)(job.isPostReviewed || false, showClientResult, timeEntered, timeDecisionMade)
            : '',
        timeWaiting: !hasDecision ? (0, translations_1.getTimeWaitingLabel)(status, timeSinceEntered) : '',
        getTimeWaitingLabel: translations_1.getTimeWaitingLabel,
        timeWaitingTooltip: !hasDecision
            ? _i18n_1.default.t('ITEM.DECISION_SUMMARY.TIME_WAITING_TOOLTIP_REACT', { TIME: timeEnteredFormatted, TIMEZONE: timeZone })
            : '',
        decisionFromNow: hasDecision
            ? (0, translations_1.getDecisionFromNowLabel)(timeNum, timeUnit)
            : '',
        getDecisionFromNowLabel: translations_1.getDecisionFromNowLabel,
        decisionFromNowTooltip: hasDecision ? (0, translations_1.getDecisionFromNowTooltipLabel)(timestampFormatted, timeZone) : '',
    };
};
exports.getDecisionSummary = getDecisionSummary;
